import React, { PropTypes } from 'react'
import styles from './ReportGraph.css'

import Ring from 'components/Common/Ring'

function ReportGraph ({ count, time, percent }) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>练习报告</div>
      <div className={styles.graph}>
        <div className={styles.count}>
          <div className={styles.text}>{ count }</div>
          <div className={styles.desc}>完成题目数</div>
        </div>
        <div className={styles.ring}>
          <Ring
            radius={80}
            ringWidth={12}
            percent={percent}
            color="#39f"
            background="#d0dce7"
            cap="round"
          >
            <div className={styles.text}>{percent}%</div>
            <div className={styles.desc}>综合正确率</div>
          </Ring>
        </div>
        <div className={styles.time}>
          <div className={styles.text}>{ time }分钟</div>
          <div className={styles.desc}>总耗时</div>
        </div>
      </div>
    </div>
  )
}

ReportGraph.propTypes = {
  count: PropTypes.number.isRequired,
  time: PropTypes.number.isRequired,
  percent: PropTypes.number.isRequired
}

export default ReportGraph



/** WEBPACK FOOTER **
 ** ./src/components/Report/ReportGraph.js
 **/